export const RECORDING_DETAILS_MODAL_CONSTANTS = {
  title: "Recording Details",
  primaryBtnText: "Close",
  shareUrlLabel: "Share URL",
  passwordLabel: "Password",
  shareUrlCopySuccess: "Share URL copied to clipboard!",
  passwordCopySuccess: "Password copied to clipboard!",
  copyShareUrlTooltip: "Copy Share URL",
  copyPasswordTooltip: "Copy Password",
};

export const MANAGE_RECORDINGS_LIST_TABLE_TEXTS = {
  HEADING: "Manage recordings",
  EMPTY_LIST_ALT: "no recordings yet.",
  EMPTY_LIST_TITLE: "No recordings.",
  EMPTY_LIST_DESC: "All your session recordings will appear here.",
  EMPTY_RECORD_FALLBACK: "-",
  PRIMARY_KEY_ID: "id",
  EMPTY_LIST_ICON_PATH: "/assets/images/manage_recordings/empty_state_icon.svg",
  LAYOUT_ROOT_CLASS: "md:tw-py-6 md:tw-mx-12",
  ALIGNMENT_SPACE_BETWEEN: "space-between",
};
